import React from 'react'
import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import { AdminTransfer } from 'src/core/models'
import { CheckOutlined } from '@ant-design/icons'
import styles from './TransferValidateButton.module.scss'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { adminTransfersSelector, validateAdminTransferSelector, validateTransfer } from 'src/features'

const TransferValidateButton: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { width } = useWindowSize()
  const isMobile = width <= 800
  const { data: oldTransferList } = useAppSelector(adminTransfersSelector)
  const { loading, currentTransfer } = useAppSelector(validateAdminTransferSelector)
  const isLoading = loading && transfer.order.id === currentTransfer

  return <>
    <Popconfirm
      disabled={isLoading}
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
      title={t('Transfer.SureValidate')}
      placement={isMobile ? 'top' : 'left'}
      cancelButtonProps={{ disabled: isLoading }}
      onConfirm={() => dispatch(validateTransfer(transfer.order.id, oldTransferList))}
    >
      <Button
        type='dashed'
        size='middle'
        loading={isLoading}
        disabled={isLoading}
        icon={<CheckOutlined />}
        className={styles.button}
      >{isLoading ? t('Transfer.Validating') : t('Transfer.Validate')}
      </Button>
    </Popconfirm>
  </>
}

export default TransferValidateButton
